import EditField from "@/components/ui/editField";
import { useProjectForm } from "@/hooks/project/useProjectForm";
import { ProjectFormData } from "@/types/project";

interface ProjectFormProps {
  initialData: ProjectFormData;
  onUpdate: (data: ProjectFormData) => void;
}

const ProjectForm: React.FC<ProjectFormProps> = ({ initialData, onUpdate }) => {
  const { formData, handleChange } = useProjectForm(initialData, onUpdate);

  return (
    <div data-testid="project-form">
      <EditField
        inputFieldName="project-name"
        value={formData.projectName}
        placeHolder="Project Name"
        className="my-2"
        textClassName="text-[16px] text-txtHeading font-bold"
        onChange={(value) => handleChange(value, "projectName")}
        testId="project-name"
      />
      <EditField
        inputFieldName="project-description"
        value={formData.projectDescription}
        placeHolder="Project Description"
        className="my-2"
        onChange={(value) => handleChange(value, "projectDescription")}
        testId="project-description"
      />
    </div>
  );
};

export default ProjectForm;
